import { render, staticRenderFns } from "./DeductionsPlansTable.vue?vue&type=template&id=36aad413&"
import script from "./DeductionsPlansTable.vue?vue&type=script&lang=js&"
export * from "./DeductionsPlansTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports